export interface ParentProgressBenefit {
  icon: string;
  title: string;
  description: string;
}

export const PARENT_PROGRESS_BENEFITS: ParentProgressBenefit[] = [
  {
    icon: 'stats/play.svg',
    title: 'Watch time in classes',
    description: 'Keep track of the time your child spends in live classes'
  },
  {
    icon: 'test-and-quiz.svg',
    title: 'Test & quiz performance',
    description:
      "Stay up to date on your child's performance in tests & quizzes"
  },
  {
    icon: 'Attendance.svg',
    title: 'Attendance',
    description: "Check your child's attendance in class on a weekly basis"
  },
  {
    icon: 'Achievements.svg',
    title: 'Achievements',
    description:
      "Get to know your child's achievements and their learning progress"
  }
];
